var App = App || {};

App.Parallax = (function ($) {

    'use strict';

    function Parallax() {
        const divisor = 2;

        $(".atom-watermark").ZagParallax({ divisor: 15 });


    }

    return {
        Parallax: Parallax
    };

})(jQuery);

$(function () {
    App.Parallax.Parallax();
});